export const DisplayDateFormat = 'MM/DD/YYYY';
export const ServerDateFormat = 'YYYY/MM/DD';
export const DateOnlyFormat = 'YYYY-MM-DD';
export const DisplayTimeFormat = 'h:mm a';
export const ServerTimeFormat = 'H:mm:ss';
// the times for promotion start/end dates
// are always treated as 12:00 AM ET
export const DefaultTimeZone = 'America/New_York';

/**
 * All admin-configurable website settings
 */
export type WebsiteSettings = {
    announcement: string;
    announcementEnabled: boolean;
    promoStartDate: string;
    promoEndDate: string;
    promoImageKey: string;
    featuredVideoId: string;
    featuredVideoTitle: string;
    outOfOfficeDates: string[];
    batchNumber: string;
    auctionEndBlacklistDates: string[];
};

export type PayoutTable = {
    rows: PayoutTableRow[];
    footer: string;
};

export type PayoutTableRow = {
    id: string;
    ordinal: number;
    salePrice: string;
    description: string;
}

export enum AnnouncementType {
    Unknown = 0,
    SiteOnly = 1,
    CustomersOnly = 2,
    SiteAndCustomers = 3,
    Breakers = 4,
    VIP = 5
}

export type FeatureFlags = Record<string, {
    minVersion: string,
    enabled: boolean
}>;